
import VI18N from 'vi18n';

const culture = document.documentElement.getAttribute('lang') || 'en-EN';

const intl = new VI18N(culture, {
	time: {
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
	},

	number: {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	},

	percent: {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	},
});

const formatNumber = number => intl.formatNumber(number);
const formatPercent = number => intl.formatPercent(number);
const formatDate = date => intl.formatDate(date);
const formatTime = date => intl.formatTime(date);
const formatDateTime = date => intl.formatDateTime(date);

const decimalSeparator = intl.getDecimalSeparator();
const thousandSeparator = intl.getThousandSeparator();

const months = intl.getMonths();
const monthsShort = intl.getMonths('short');

export {
	culture,
	formatNumber,
	formatPercent,
	formatDate,
	formatTime,
	formatDateTime,

	months,
	monthsShort,

	decimalSeparator,
	thousandSeparator,
};
